import React from 'react';
import { Checkbox } from '@sm/wds-react';
import { SearchConsumer } from '../SearchContext';

import { DEFAULT_FILTERS, APP_CATEGORIES, INTEGRATE_TYPES, AVAILABLE_IN } from '../SearchContext/FilterOptions';

const FilterNav = () => {
  return (
    <SearchConsumer>
      {({ filters, updateFilter }) => {
        const isChecked = filter => filters.includes(filter);
        const handleChange = filter =>
          updateFilter(isChecked(filter) ? filters.filter(f => f !== filter) : [...filters, filter]);

        const renderFilter = ({ name, key, id }) => (
          <div key={id || key}>
            <Checkbox
              label={name}
              id={id || key}
              data-testid="FilterNav__CategoryItem"
              onChange={() => handleChange(key)}
              checked={isChecked(key)}
            />
          </div>
        );

        return (
          <div>
            <h2>Filter</h2>
            {DEFAULT_FILTERS.map(cat => renderFilter(cat))}
            <h3>App Category</h3>
            {/* TODO: use a query to fetch the application categories (INTEGRATE-3825) */}
            {APP_CATEGORIES.map(cat => renderFilter(cat))}
            <h3>Integration Type</h3>
            {INTEGRATE_TYPES.map(cat => renderFilter(cat))}
            <h3>Available in</h3>
            {AVAILABLE_IN.map(cat => renderFilter(cat))}
          </div>
        );
      }}
    </SearchConsumer>
  );
};

export default FilterNav;
